var d = /* @__PURE__ */ ((r) => (r.PreOrder = "PreOrder", r.OrderNow = "OrderNow", r.Closed = "Closed", r))(d || {}), a = /* @__PURE__ */ ((r) => (r[r.Standard = 0] = "Standard", r[r.Summer = 1] = "Summer", r))(a || {});
export {
  d as OutletListSection,
  a as PickerTimeTimezoneTag
};
